<template>
  <div id="home">
    <headerbom></headerbom>
    <div class="home-banner-kuan">
      <div class="home-banner">
        <!-- <h1>
        让数据更懂你</br>
        让推广更简单
      </h1>
      <img src="../img/home1.png" alt=""> -->
        <video-player ref="videoPlayer" :options="playerOptions"></video-player>
      </div>
    </div>
    <div class="title_box">
      <h1>业务生态</h1>
      <p>专注移动营销数据赋能，探索效果领域无限可能</p>
    </div>
    <ul class="home_introduce">
      <li>
        <img src="../img/home2.png" alt="">
        <section>
          <h2>巨掌ASO</h2>
          <p>苹果应用商店优化：App store opetimization，简称“ASO”，即优化关键词覆盖排名等。</p>
        </section>
      </li>
      <li>
        <section>
          <h2>巨掌ASA</h2>
          <p>苹果应用商店搜索市场：App Store Search Marketing，简称ASM；苹果官方又称为Search Ads，简称ASA。</p>
        </section>
        <img src="../img/home3.png" alt="" style="margin: 0 0 0 0.4rem">
      </li>
      <li>
        <img src="../img/home4.png" alt="">
        <section>
          <h2>游戏SaaS</h2>
          <p>休闲式场景营销，帮助互联网企业提升运营效果，提升变现效率，帮助广告主提高转化效果，不断提升用户体验，实现三方共赢。</p>
        </section>
      </li>
    </ul>
    <div class="title_box">
      <h1>最新动态</h1>
      <p>公司实时动态，行业最新资讯，一手掌握</p>
    </div>
    <div class="home_news">
      <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
        <van-swipe-item>
          <div>
            <img src="../img/home5.png" alt="">
          </div>
          <h1>
            企业动态
            <span @click="tonews(0)">查看更多></span>
          </h1>
          <ul>
            <li v-for="(ele,index) in newslist1" :key="index" v-if="index<5">
              <p><a :href="ele.alink">{{ele.title}}</a></p>
              <span>{{ele.date}}</span>
            </li>
          </ul>
        </van-swipe-item>
        <van-swipe-item>
          <div>
            <img src="../img/home6.jpg" alt="">
          </div>
          <h1>
            行业动态
            <span @click="tonews(1)">查看更多></span>
          </h1>
          <ul>
            <li v-for="(ele,index) in newslist2" :key="index" v-if="index<5">
              <p><a :href="ele.alink">{{ele.title}}</a></p>
              <span>{{ele.date}}</span>
            </li>
          </ul>
        </van-swipe-item>
      </van-swipe>
    </div>
    <div class="title_box">
      <h1>合作伙伴</h1>
      <p>累计服务超过2000家企业和应用开发者，拥有一批互信共赢的头部企业</p>
    </div>
    <div class="home_friend">
      <section>
        <div v-for="(ele,index) in frlist" :key="index" :class="{noleft: index % 3 == 0}">
          <img :src="ele" alt="">
        </div>
      </section>
    </div>
    <div class="home_fr_mo" @click="tofriend">
      查看更多
      <i class="iconfont iconxia"></i>
    </div>
    <footerbom></footerbom>
  </div>
</template>

<script type="text/javascript">
export default {
  data() {
    return {
      playerOptions: {
        playbackRates: [0.5, 1.0, 1.5, 2.0],
        autoplay: false,
        muted: false,
        loop: false,
        preload: "auto",
        language: "zh-CN",
        aspectRatio: "16:9",
        fluid: true,
        sources: [
          {
            type: "",
            src: "https://static.adjuz.com/adjuz-website/m_adjuzmv1.mp4",
          },
        ],
        poster: require("../img/home1.png"),
        notSupportedMessage: "此视频暂无法播放，请稍后再试",
        controlBar: {
          timeDivider: false,
          durationDisplay: false,
          remainingTimeDisplay: false,
          fullscreenToggle: false,
        },
      },
      newslist1: [
        {
          alink:
            "http://mp.weixin.qq.com/s?__biz=MzU5Mjg0MzA2NQ==&mid=100006882&idx=1&sn=e2e08e44598475e3a7da42c854c86e3c&chksm=7e18c3b4496f4aa29fff65a3824b2519083d8bb20108f5eb6e601fd8a3e2c194813a2ece34ff#rd",
          title: "合力精耕，共创巨掌美好明天——巨掌数据尾牙晚宴完美收官",
          date: "2021-01-18",
        },
        {
          alink: "https://mp.weixin.qq.com/s/TpepifxunuOAJdZH-i9mkA",
          title: "风云再起，冠军诞生！巨掌第三届王者荣耀比赛完美收官",
          date: "2020-11-23",
        },
        {
          alink: "https://mp.weixin.qq.com/s/PtBgfCLNyAw8lT9ET_vJHw",
          title: "2020巨掌羽毛球篮球赛，舞动精彩，闪耀未来！",
          date: "2020-11-26",
        },
        {
          alink: "https://mp.weixin.qq.com/s/gxNtov2oQDTqlDS6P5S54A",
          title: "好消息！巨掌ASA海外优化团队全员通过苹果认证！",
          date: "2020-08-24",
        },
        {
          alink: "https://mp.weixin.qq.com/s/-cU_5pGfEq4_Pe0h-ggQLQ",
          title: "燃爆了!【掌上王者】王者荣耀战队赛收官，冠军登顶宝座！",
          date: "2020-06-30",
        },
        {
          alink: "https://mp.weixin.qq.com/s/nvC2h_2v5VBPqTv6apGMDw",
          title: "重磅！苹果竞价广告ASA即将新登录俄罗斯，巨掌数据同步更新！",
          date: "2020-04-07",
        },
        {
          alink: "http://it.people.com.cn/n1/2020/0110/c1009-31543884.html",
          title: "首届移动互联网应用安全发展峰会在京举行",
          date: "2020-01-10",
        },
        {
          alink: "https://mp.weixin.qq.com/s/JenySHd1_CMyTEUZ2Cr03A",
          title:
            "《颠覆重塑 · 2019巨掌效果营销线下干货私享会 》广州站圆满落幕！",
          date: "2019-08-27",
        },
        {
          alink: "https://mp.weixin.qq.com/s/x_bZH-Qngu1bxC4ML8ZGZg",
          title:
            "巨掌数据新品发布：只为帮助广告主高效制定投放策略和进行广告投放",
          date: "2019-08-05",
        },
        {
          alink: "https://mp.weixin.qq.com/s/-pge7X8JLAi4leaU-HBQjw",
          title: "6000字珍藏私货：大佬关于未来效果营销模式的深度碰撞！速看！",
          date: "2019-08-14",
        },
        {
          alink: "https://mp.weixin.qq.com/s/ZbNgIkmypNhHljXzFWNddA",
          title:
            "巨掌品牌战略升级：专注“数据+效果​”，让数据更懂你，让推广更简单",
          date: " 2019-08-03",
        },
        {
          alink: "https://mp.weixin.qq.com/s/FfVRem0o6Sib7-9Bs1PYjQ",
          title:
            "《颠覆重塑 · 2019巨掌效果营销线下干货私享会 》北京站圆满落幕！",
          date: "2019-07-05",
        },
        {
          alink: "https://mp.weixin.qq.com/s/1rkaqw4vvXgbfKihrxQXGQ",
          title: "差距啊！吃喝玩乐...瞧瞧别人家公司的61福利！",
          date: "2019-05-31",
        },
        {
          alink: "https://mp.weixin.qq.com/s/_EZaxeE64e8Fyt-S3fRI3w",
          title: "巨掌广告五周年庆典活动 | 巨掌进击，所向披靡！",
          date: "2019-04-18",
        },
        {
          alink: "https://mp.weixin.qq.com/s/AZ3wzZTd7JSGgt2kjGOqRQ",
          title:
            "好消息！巨掌广告抢先上线港澳台ASM数据查询，助力广告主挖掘流量红利",
          date: "2019-04-15",
        },
      ],
      newslist2: [
        {
          alink: "https://mp.weixin.qq.com/s/7BSPvuX1ggiW92OIvsOnXQ",
          title: "打通手机电脑软件，苹果推出划时代芯片，今天的发布会将永载史册",
          date: "2020-11-11",
        },
        {
          alink: "https://mp.weixin.qq.com/s/UK3l_o5ZPlpMveJbgB8K4A",
          title: "重要！苹果隐私标签新规12月8日上线，开发者务必引起重视",
          date: "2020-11-09",
        },
        {
          alink: "https://mp.weixin.qq.com/s/PNbIMmjNupy9T8cLqO4lIQ",
          title: "突发！韩国提案强制应用上架全部应用商店，出海韩国要谨慎了",
          date: "2020-10-22",
        },
        {
          alink: "https://mp.weixin.qq.com/s/y2Jk9SCAOxu_iWBI66Fe3g",
          title: "重磅！苹果修改App Store审核指南，利好开发者！",
          date: "2020-09-14",
        },
        {
          alink: "https://mp.weixin.qq.com/s/Ntxpcdb2FEsEE0X-M0y6Bw",
          title:
            "疫情影响下哪些App吸金最多、下载最多？2020年上半年App排行揭晓！",
          date: "2020-07-02",
        },
        {
          alink: "https://mp.weixin.qq.com/s/XgQl9GVzXH6RdTx8IQNVNA",
          title: "太难了！5月下架7万App，东北互联网行业收入又双叒叕下降！",
          date: "2020-06-30",
        },
        {
          alink: "https://mp.weixin.qq.com/s/ozUYWAd4fCS3OWDm-H8X-w",
          title:
            "开发者福音！苹果推应用内购买通知系统：让开发者知道客户何时申请退款",
          date: "2020-06-28",
        },
        {
          alink: "https://mp.weixin.qq.com/s/xy8mPRjHCzoe5us2AbEqoA",
          title: "泄密内容最多的一届全球开发者大会，苹果WWDC20发布会重点整理",
          date: "2020-06-23",
        },
        {
          alink: "https://mp.weixin.qq.com/s/FWqLtvlW837VsCIZQZVS0g",
          title:
            "苹果首次公布：App Store年收入5190亿美元，中国超美国成第一市场",
          date: "2020-06-16",
        },
        {
          alink: "https://mp.weixin.qq.com/s/h-pSH1uyk_MZ9579ZjoeQg",
          title: "中国新闻平台三强争霸，数据显示iPhone用户更爱腾讯、新浪新闻",
          date: "2020-06-11",
        },
        {
          alink: "https://mp.weixin.qq.com/s/lRgbcsxiieZwJorsBXXqTQ",
          title:
            "“山寨”App大撒红包，勇夺App Store总榜第一！网友：这套路真熟悉！",
          date: "2020-06-08",
        },
        {
          alink: "https://mp.weixin.qq.com/s/wbXULx4swv0s_d55UP2YYw",
          title: "真的活下来了！4月上架19万App，行业利润终止下滑！",
          date: "2020-06-01",
        },
        {
          alink: "https://mp.weixin.qq.com/s/rchgS8TeQ0L_RtGN6zfABw",
          title: "大乱斗！快手、抖音互相起诉对方？事情真相原来是这样！",
          date: "2020-05-13",
        },
        {
          alink: "https://mp.weixin.qq.com/s/VLKo8PPfYGAZNEUyCjqRdA",
          title: "2020年专项治理！App违法违规收集使用个人信息将严查",
          date: "2020-04-24",
        },
      ],
      frlist: [
        require("../img/home7.png"),
        require("../img/home8.png"),
        require("../img/home9.png"),
        require("../img/home10.png"),
        require("../img/home11.png"),
        require("../img/home12.png"),
        require("../img/home13.png"),
        require("../img/home14.png"),
        require("../img/home15.png"),
      ],
    };
  },
  computed: {},
  components: {},
  created() {},
  destroyed() {},
  mounted() {
    // setTimeout(() => {
    //   this.$refs.videoPlayer.player.play();
    // }, 3000);
  },
  methods: {
    tofriend() {
      window.open(this.$router.resolve({ path: "/friend" }).href, "_blank");
    },
    tonews(num) {
      if (num == 1) {
        window.open(this.$router.resolve({ path: "/news" }).href, "_blank");
      } else {
        window.open(
          this.$router.resolve({ path: "/news", query: { type: "enterprise" } })
            .href,
          "_blank"
        );
      }
    },
  },
};
</script>

<style lang="less" scoped>
#home {
  padding-top: 1rem;
  .home-banner-kuan {
    min-height: 4.24rem;
    background: url("../img/home1.png") no-repeat center center;
    background-size: cover;
  }
  .home-banner {
    position: relative;
    img {
      width: 100%;
      height: auto;
    }
    h1 {
      font-size: 0.44rem;
      position: absolute;
      left: 0.3rem;
      color: #fff;
      top: 45%;
      transform: translateY(-50%);
      line-height: 0.8rem;
      letter-spacing: 0.02rem;
    }
  }
  .title_box {
    width: 100%;
    height: 2.5rem;
    text-align: center;
    overflow: hidden;
    box-sizing: border-box;
    padding: 0 0.3rem;
    h1 {
      font-size: 0.36rem;
      font-weight: bold;
      columns: #333;
      margin: 0.86rem 0 0.26rem;
    }
    p {
      font-size: 0.28rem;
      color: #666;
    }
  }
  .home_introduce {
    width: 100%;
    box-sizing: border-box;
    padding: 0 0.22rem;
    li {
      border: 0.01rem solid @border;
      border-radius: 0.12rem;
      box-sizing: border-box;
      padding: 0.34rem;
      display: flex;
      align-items: center;
      margin-bottom: 0.3rem;
      &:last-child {
        margin-bottom: 0;
      }
      img {
        width: 1.3rem;
        height: auto;
        flex-shrink: 0;
        margin-right: 0.4rem;
      }
      h2 {
        font-size: 0.32rem;
        color: @h1;
        font-weight: bold;
        margin-bottom: 0.12rem;
      }
      p {
        font-size: 0.28rem;
        color: @p;
        line-height: 0.4rem;
      }
    }
  }
  .my-swipe {
    width: 100%;
    background: #fff;
    padding-bottom: 0.7rem;
    div {
      height: 4rem;
      overflow: hidden;
    }
    img {
      width: 100%;
      height: auto;
    }
    h1 {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 0.44rem;
      font-size: 0.36rem;
      color: @h1;
      box-sizing: border-box;
      padding: 0.44rem 0.22rem 0;
      font-weight: bold;
      span {
        font-size: 0.28rem;
        color: @p;
        font-weight: 400;
      }
    }
    ul {
      box-sizing: border-box;
      padding: 0 0.4rem 0 0.22rem;
      li {
        border-bottom: 0.01rem solid @border;
        padding: 0.44rem 0;
        p {
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          width: 100%;
          margin-bottom: 0.2rem;
        }
        a {
          color: @h1;
          font-size: 0.28rem;
          &:active {
            color: @color;
          }
        }
        span {
          font-size: 0.24rem;
          color: @span;
        }
      }
    }
  }
  .home_friend {
    box-sizing: border-box;
    padding: 0.2rem 0.22rem;
    section {
      display: flex;
      flex-wrap: wrap;
      width: 100%;
    }
    div {
      border: 0.01rem solid @border;
      border-radius: 0.1rem;
      width: 30%;
      height: 0.94rem;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-left: 5%;
      box-sizing: border-box;
      margin-bottom: 0.3rem;
      &.noleft {
        margin-left: 0;
      }
      img {
        width: 1.8rem;
        height: auto;
      }
    }
  }
  .home_fr_mo {
    text-align: center;
    font-size: 0.28rem;
    color: #000;
    margin: 0.28rem 0 1rem;
    i {
      margin-left: 0.1rem;
      font-size: 0.22rem;
    }
  }
}
</style>
<style lang="less">
#home {
  video {
    outline: none;
    border: none;
    width: 100% !important;
    //object-fit: fill;
  }
  .vjs-poster {
    background-size: cover;
  }
  .vjs-big-play-button {
    width: 0.9rem;
    height: 0.9rem;
    border-radius: 50%;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 50%;
    border: none;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    .vjs-icon-placeholder {
      width: 1.1rem;
      height: 1.1rem;
      border-radius: 50%;
      &::before {
        font-size: 0.4rem;
        line-height: 0.9rem;
      }
    }
  }
  .vjs-control-bar {
    display: none !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/page/home/index.vue